module.exports = __webpack_public_path__ + "img/wallet.4a23aae7.svg";